import { GraphQL } from "@rpi/openapi-api";

/**
 * Customer-facing copy for a recorded cancellation outcome.
 *
 * Outcomes that produced a refund are absent until a refunded payment status
 * exists to sit beside them, so they fall through to the caller's fallback.
 */
const OUTCOME_COPY = new Map<GraphQL.CancellationOutcome, string>([
  [
    GraphQL.CancellationOutcome.RefusedAlreadyShipping,
    "This order was already shipping and couldn't be cancelled. It's on its way.",
  ],
]);

export function cancellationOutcomeCopy(outcome: GraphQL.CancellationOutcome | null | undefined): string | undefined {
  return outcome ? OUTCOME_COPY.get(outcome) : undefined;
}
